export default __webpack_public_path__ + "static/media/worstpainsmile.4a813ec5.svg";